import React from 'react';
import { useTranslation } from 'react-i18next';

const LoadingSpinner = ({ size = 16, showText = true, text }) => {
  const { t } = useTranslation('common');
  const resolvedText = text === undefined ? t('loading') : text;

  return (
    <div className="min-h-screen flex items-center justify-center" role="status" aria-live="polite">
      <div className="text-center">
        <div className={`animate-spin rounded-full h-${size} w-${size} border-b-2 border-blue-500 mx-auto`}></div>
        {showText && <p className="mt-4 text-gray-600 text-lg">{resolvedText}</p>}
      </div>
    </div>
  );
};

export default LoadingSpinner;
